import MessagingBase from './messaging-base';

export default class MessagingConversation extends MessagingBase {
  serialize() {
    let json = super.serialize(...arguments);
    // Conversation updates currently only accept display_name.
    json.data.attributes = {
      'display_name': json.data.attributes?.display_name ?? null,
    };
    delete json.data.relationships;
    return json;
  }
}
